import { useState, useRef } from 'react'

/**
 * Hook para gerenciar upload de arquivos com drag & drop
 * 
 * Single Responsibility: Apenas gerenciamento de arquivos
 */
export function useFileUpload() {
  const [files, setFiles] = useState([])
  const [isDragging, setIsDragging] = useState(false)
  const fileInputRef = useRef(null)

  const handleFilesChange = (e) => {
    const newFiles = Array.from(e.target.files)
    setFiles(prev => [...prev, ...newFiles])
  }

  const handleRemoveFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index))
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    setIsDragging(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setIsDragging(false)
    const droppedFiles = Array.from(e.dataTransfer.files)
    setFiles(prev => [...prev, ...droppedFiles])
  }

  const clearFiles = () => {
    setFiles([])
  }

  const openFilePicker = () => {
    fileInputRef.current?.click()
  }

  return {
    files,
    isDragging,
    fileInputRef,
    handleFilesChange,
    handleRemoveFile,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    clearFiles,
    openFilePicker
  }
}
